import MaintenanceDetail from './MaintenanceDetail.vue'

export default MaintenanceDetail


// WEBPACK FOOTER //
// ./src/pages/MaintenanceDetail/index.js